import { Project } from '../../types/project.types';
import { ProjectCard } from './ProjectCard';

interface ProjectListProps {
  projects: Project[];
  onDelete: (projectId: string) => void;
}

export function ProjectList({ projects, onDelete }: ProjectListProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {projects.map((project) => (
        <ProjectCard key={project.id} project={project} onDelete={onDelete} />
      ))}
    </div>
  );
}
